import React, { useEffect } from "react";
import { Dialog, DialogClose, DialogContent } from "@ui/dialog";
import { addItemToPlaylist, useAppDispatch, useAppSelector } from "@lib/stores";
import { getPlaylistsAsync } from "@lib/stores/myLibrary/slices";
import { getPublicMediaUrl } from "@modules/api/util/mediaHelper";
import { SVG } from "@components/items/common/SVG";
import { Separator } from "@ui/separator";
import AddPlaylistDialog from "./AddPlaylistDialog";
import { X } from "lucide-react";
import TranslatedText from "@components/items/display/TranslatedText";

const CurrentPlaylists = ({
  isOpen,
  setOpen,
  contentId,
}: {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  contentId: string | undefined;
}) => {
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state.myLibrary.playlists);

  useEffect(() => {
    dispatch(getPlaylistsAsync());
  }, [dispatch]);

  return (
    <Dialog open={isOpen}>
      <DialogContent className="flex max-h-[90vh] w-3/4 flex-col bg-white sm:w-1/3 dark:bg-[#3C3B40] [&>button]:hidden">
        <div className="flex items-center justify-between p-4">
          <DialogClose asChild={true}>
            <X
              className="cursor-pointer justify-start dark:text-white"
              onClick={() => setOpen(!isOpen)}
            />
          </DialogClose>
          <div className="ms-auto">
            <AddPlaylistDialog />
          </div>
        </div>

        <div className="cus-scrollbar-w-none max-h-[500px] flex-1 overflow-y-auto px-4 pb-4">
          {data.length > 0 ? (
            data.map((p) => (
              <div
                key={p.id}
                className="flex cursor-pointer flex-col gap-3 rounded-lg pt-2 hover:bg-gray-100 dark:hover:bg-gray-700"
                onClick={() => {
                  const input = {
                    playlistId: p.id,
                    contentEntityId: contentId,
                  };

                  addItemToPlaylist(input, () => {
                    setOpen(false);
                  });
                }}
              >
                <div className="flex items-center gap-3">
                  {p?.picture ? (
                    <img
                      src={getPublicMediaUrl(p?.picture)}
                      alt="No item"
                      className="h-[70px] w-[70px] rounded-lg object-cover"
                    />
                  ) : (
                    <div className="flex h-[70px] w-[70px] items-center justify-center rounded-lg bg-[#9999992B]/15 p-2">
                      <SVG src="/assets/icons/empty-playlist.svg" />
                    </div>
                  )}
                  <div className="flex-1 truncate dark:text-white">
                    {p.title}
                  </div>
                </div>
                <Separator />
              </div>
            ))
          ) : (
            <TranslatedText
              className="flex items-center justify-center text-[15px] dark:text-white"
              text={`my-library.${"no lists"}`}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CurrentPlaylists;
